<!--
component: BrowseBuildingNobemen
author: Ken Nakamura
description: 建築計画概要書（第二面 延べ面積）
-->
<template>
  <section>
    <div class="gaiyo-row">
      <div class="gaiyo-major-title">【11.延べ面積】</div>
      <div class="gaiyo-headers">
        <div class="gaiyo-element left-50">(</div>
        <div class="gaiyo-element left-90">&nbsp;) (</div>
        <div class="gaiyo-element left-130">&nbsp;) (</div>
        <div class="gaiyo-element left-170">&nbsp;)</div>
        <div class="gaiyo-header left-65">申請部分</div>
        <div class="gaiyo-header left-100">&nbsp;申請以外の部分</div>
        <div class="gaiyo-header item-3">合計</div>
      </div>
    </div>
    <div class="gaiyo-row">
      <div class="gaiyo-minor-title">【ｲ.建築物全体】</div>
      <div class="gaiyo-items">
        <div class="gaiyo-element left-50">(</div>
        <div class="gaiyo-element left-90">&nbsp;) (</div>
        <div class="gaiyo-element left-130">&nbsp;) (</div>
        <div class="gaiyo-element left-170">&nbsp;)</div>
        <div class="gaiyo-item item-1">{{fmt(gaiyo.gaiyoRec.nB_TOTAL_BBN, 2)}} ㎡</div>
        <div class="gaiyo-item item-2">{{fmt(gaiyo.gaiyoRec.nB_TOTAL_IGI, 2)}} ㎡</div>
        <div class="gaiyo-item item-3">{{fmt(gaiyo.gaiyoRec.nB_TOTAL_SUM, 2)}} ㎡</div>
      </div>
    </div>
    <div class="gaiyo-row">
      <div class="gaiyo-minor-title">【ﾛ.地階の住宅又は老人ホーム等の部分】</div>
    </div>
    <div class="gaiyo-row">
      <div class="gaiyo-items">
        <div class="gaiyo-element left-50">(</div>
        <div class="gaiyo-element left-90">&nbsp;) (</div>
        <div class="gaiyo-element left-130">&nbsp;) (</div>
        <div class="gaiyo-element left-170">&nbsp;)</div>
        <div class="gaiyo-item item-1">{{fmt(gaiyo.gaiyoRec.nB_TIKAI_BBN, 2)}} ㎡</div>
        <div class="gaiyo-item item-2">{{fmt(gaiyo.gaiyoRec.nB_TIKAI_IGI, 2)}} ㎡</div>
        <div class="gaiyo-item item-3">{{fmt(gaiyo.gaiyoRec.nB_TIKAI_SUM, 2)}} ㎡</div>
      </div>
      <div style="line-height:9pt;"><br></div>
    </div>
    <div class="gaiyo-row">
      <div class="gaiyo-minor-title">【ﾊ.エレベーターの昇降路の部分】</div>
    </div>
    <div class="gaiyo-row">
      <div class="gaiyo-items">
        <div class="gaiyo-element left-50">(</div>
        <div class="gaiyo-element left-90">&nbsp;) (</div>
        <div class="gaiyo-element left-130">&nbsp;) (</div>
        <div class="gaiyo-element left-170">&nbsp;)</div>
        <div class="gaiyo-item item-1">{{fmt(gaiyo.gaiyoRec.nB_ELEV_BBN, 2)}} ㎡</div>
        <div class="gaiyo-item item-2">{{fmt(gaiyo.gaiyoRec.nB_ELEV_IGI, 2)}} ㎡</div>
        <div class="gaiyo-item item-3">{{fmt(gaiyo.gaiyoRec.nB_ELEV_SUM, 2)}} ㎡</div>
      </div>
      <div style="line-height:9pt;"><br></div>
    </div>
    <div class="gaiyo-row">
      <div class="gaiyo-minor-title">【ﾆ.共同住宅又は老人ホーム等の共用の廊下等の部分】</div>
    </div>
    <div class="gaiyo-row">
      <div class="gaiyo-items">
        <div class="gaiyo-element left-50">(</div>
        <div class="gaiyo-element left-90">&nbsp;) (</div>
        <div class="gaiyo-element left-130">&nbsp;) (</div>
        <div class="gaiyo-element left-170">&nbsp;)</div>
        <div class="gaiyo-item item-1">{{fmt(gaiyo.gaiyoRec.nB_KYODO_BBN, 2)}} ㎡</div>
        <div class="gaiyo-item item-2">{{fmt(gaiyo.gaiyoRec.nB_KYODO_IGI, 2)}} ㎡</div>
        <div class="gaiyo-item item-3">{{fmt(gaiyo.gaiyoRec.nB_KYODO_SUM, 2)}} ㎡</div>
      </div>
      <div style="line-height:9pt;"><br></div>
    </div>
    <!-- 法改正対応 新たに追加項目 2023/03/31-->
    <div class="gaiyo-row">
      <div class="gaiyo-minor-title">【ﾎ.認定機械室等の部分】</div>
      <div class="gaiyo-items">
        <div class="gaiyo-element left-50">(</div>
        <div class="gaiyo-element left-90">&nbsp;) (</div>
        <div class="gaiyo-element left-130">&nbsp;) (</div>
        <div class="gaiyo-element left-170">&nbsp;)</div>
        <div class="gaiyo-item item-1">{{fmt(gaiyo.gaiyoRec.nB_MACHINE_BBN, 2)}} ㎡</div>
        <div class="gaiyo-item item-2">{{fmt(gaiyo.gaiyoRec.nB_MACHINE_IGI, 2)}} ㎡</div>
        <div class="gaiyo-item item-3">{{fmt(gaiyo.gaiyoRec.nB_MACHINE_SUM, 2)}} ㎡</div>
      </div>
    </div>
    <div class="gaiyo-row">
      <div class="gaiyo-minor-title">【ﾍ.自動車車庫等の部分】</div>
      <div class="gaiyo-items">
        <div class="gaiyo-element left-50">(</div>
        <div class="gaiyo-element left-90">&nbsp;) (</div>
        <div class="gaiyo-element left-130">&nbsp;) (</div>
        <div class="gaiyo-element left-170">&nbsp;)</div>
        <div class="gaiyo-item item-1">{{fmt(gaiyo.gaiyoRec.nB_GARAGE_BBN, 2)}} ㎡</div>
        <div class="gaiyo-item item-2">{{fmt(gaiyo.gaiyoRec.nB_GARAGE_IGI, 2)}} ㎡</div>
        <div class="gaiyo-item item-3">{{fmt(gaiyo.gaiyoRec.nB_GARAGE_SUM, 2)}} ㎡</div>
      </div>
    </div>
    <div class="gaiyo-row">
      <div class="gaiyo-minor-title">【ﾄ.備蓄倉庫の部分】</div>
      <div class="gaiyo-items">
        <div class="gaiyo-element left-50">(</div>
        <div class="gaiyo-element left-90">&nbsp;) (</div>
        <div class="gaiyo-element left-130">&nbsp;) (</div>
        <div class="gaiyo-element left-170">&nbsp;)</div>
        <div class="gaiyo-item item-1">{{fmt(gaiyo.gaiyoRec.nB_BITIKU_BBN, 2)}} ㎡</div>
        <div class="gaiyo-item item-2">{{fmt(gaiyo.gaiyoRec.nB_BITIKU_IGI, 2)}} ㎡</div>
        <div class="gaiyo-item item-3">{{fmt(gaiyo.gaiyoRec.nB_BITIKU_SUM, 2)}} ㎡</div>
      </div>
    </div>
    <div class="gaiyo-row">
      <div class="gaiyo-minor-title">【ﾁ.蓄電池の設備部分】</div>
      <div class="gaiyo-items">
        <div class="gaiyo-element left-50">(</div>
        <div class="gaiyo-element left-90">&nbsp;) (</div>
        <div class="gaiyo-element left-130">&nbsp;) (</div>
        <div class="gaiyo-element left-170">&nbsp;)</div>
        <div class="gaiyo-item item-1">{{fmt(gaiyo.gaiyoRec.nB_BATTERY_BBN, 2)}} ㎡</div>
        <div class="gaiyo-item item-2">{{fmt(gaiyo.gaiyoRec.nB_BATTERY_IGI, 2)}} ㎡</div>
        <div class="gaiyo-item item-3">{{fmt(gaiyo.gaiyoRec.nB_BATTERY_SUM, 2)}} ㎡</div>
      </div>
    </div>
    <div class="gaiyo-row">
      <div class="gaiyo-minor-title">【ﾘ.自家発電設備の設置部分】</div>
    </div>
    <div class="gaiyo-row">
      <div class="gaiyo-items">
        <div class="gaiyo-element left-50">(</div>
        <div class="gaiyo-element left-90">&nbsp;) (</div>
        <div class="gaiyo-element left-130">&nbsp;) (</div>
        <div class="gaiyo-element left-170">&nbsp;)</div>
        <div class="gaiyo-item item-1">{{fmt(gaiyo.gaiyoRec.nB_HATUDEN_BBN, 2)}} ㎡</div>
        <div class="gaiyo-item item-2">{{fmt(gaiyo.gaiyoRec.nB_HATUDEN_IGI, 2)}} ㎡</div>
        <div class="gaiyo-item item-3">{{fmt(gaiyo.gaiyoRec.nB_HATUDEN_SUM, 2)}} ㎡</div>
      </div>
      <div style="line-height:9pt;"><br></div>
    </div>
    <div class="gaiyo-row">
      <div class="gaiyo-minor-title">【ﾇ.貯水槽の設置部分】</div>
      <div class="gaiyo-items">
        <div class="gaiyo-element left-50">(</div>
        <div class="gaiyo-element left-90">&nbsp;) (</div>
        <div class="gaiyo-element left-130">&nbsp;) (</div>
        <div class="gaiyo-element left-170">&nbsp;)</div>
        <div class="gaiyo-item item-1">{{fmt(gaiyo.gaiyoRec.nB_CHOSUISO_BBN, 2)}} ㎡</div>
        <div class="gaiyo-item item-2">{{fmt(gaiyo.gaiyoRec.nB_CHOSUISO_IGI, 2)}} ㎡</div>
        <div class="gaiyo-item item-3">{{fmt(gaiyo.gaiyoRec.nB_CHOSUISO_SUM, 2)}} ㎡</div>
      </div>
    </div>
    <div class="gaiyo-row">
      <div class="gaiyo-minor-title">【ﾙ.宅配ボックスの設置部分】</div>
    </div>
    <div class="gaiyo-row">
      <div class="gaiyo-items">
        <div class="gaiyo-element left-50">(</div>
        <div class="gaiyo-element left-90">&nbsp;) (</div>
        <div class="gaiyo-element left-130">&nbsp;) (</div>
        <div class="gaiyo-element left-170">&nbsp;)</div>
        <div class="gaiyo-item item-1">{{fmt(gaiyo.gaiyoRec.nB_TAKUHAI_BBN, 2)}} ㎡</div>
        <div class="gaiyo-item item-2">{{fmt(gaiyo.gaiyoRec.nB_TAKUHAI_IGI, 2)}} ㎡</div>
        <div class="gaiyo-item item-3">{{fmt(gaiyo.gaiyoRec.nB_TAKUHAI_SUM, 2)}} ㎡</div>
      </div>
      <div style="line-height:9pt;"><br></div>
    </div>
    <!-- 法改正対応 新たに追加項目 2023/03/31-->
    <div class="gaiyo-row">
      <div class="gaiyo-minor-title">【ｦ.その他の不算入部分】</div>
      <div class="gaiyo-items">
        <div class="gaiyo-element left-50">(</div>
        <div class="gaiyo-element left-90">&nbsp;) (</div>
        <div class="gaiyo-element left-130">&nbsp;) (</div>
        <div class="gaiyo-element left-170">&nbsp;)</div>
        <div class="gaiyo-item item-1">{{fmt(gaiyo.gaiyoRec.nB_FUSANNYU_BBN, 2)}} ㎡</div>
        <div class="gaiyo-item item-2">{{fmt(gaiyo.gaiyoRec.nB_FUSANNYU_IGI, 2)}} ㎡</div>
        <div class="gaiyo-item item-3">{{fmt(gaiyo.gaiyoRec.nB_FUSANNYU_SUM, 2)}} ㎡</div>
      </div>
    </div>
    <div class="gaiyo-row">
      <div class="gaiyo-minor-title">【ﾜ.住宅の部分】</div>
      <div class="gaiyo-items">
        <div class="gaiyo-element left-50">(</div>
        <div class="gaiyo-element left-90">&nbsp;) (</div>
        <div class="gaiyo-element left-130">&nbsp;) (</div>
        <div class="gaiyo-element left-170">&nbsp;)</div>
        <div class="gaiyo-item item-1">{{fmt(gaiyo.gaiyoRec.nB_HOUSE_BBN, 2)}} ㎡</div>
        <div class="gaiyo-item item-2">{{fmt(gaiyo.gaiyoRec.nB_HOUSE_IGI, 2)}} ㎡</div>
        <div class="gaiyo-item item-3">{{fmt(gaiyo.gaiyoRec.nB_HOUSE_SUM, 2)}} ㎡</div>
      </div>
    </div>
    <div class="gaiyo-row">
      <div class="gaiyo-minor-title">【ｶ.老人ホーム等の部分】</div>
      <div class="gaiyo-items">
        <div class="gaiyo-element left-50">(</div>
        <div class="gaiyo-element left-90">&nbsp;) (</div>
        <div class="gaiyo-element left-130">&nbsp;) (</div>
        <div class="gaiyo-element left-170">&nbsp;)</div>
        <div class="gaiyo-item item-1">{{fmt(gaiyo.gaiyoRec.nB_FUKUSHI_BBN, 2)}} ㎡</div>
        <div class="gaiyo-item item-2">{{fmt(gaiyo.gaiyoRec.nB_FUKUSHI_IGI, 2)}} ㎡</div>
        <div class="gaiyo-item item-3">{{fmt(gaiyo.gaiyoRec.nB_FUKUSHI_SUM, 2)}} ㎡</div>
      </div>
    </div>
    <div class="gaiyo-row">
      <div class="gaiyo-minor-title">【ﾖ.延べ面積】</div>
      <div class="gaiyo-items">
        <div class="gaiyo-item item-1">{{fmt(gaiyo.gaiyoRec.nB_AREA_KIJUNHO, 2)}} ㎡</div>
      </div>
    </div>
    <div class="gaiyo-row">
      <div class="gaiyo-minor-title">【ﾀ.容積率】</div>
      <div class="gaiyo-items">
        <div class="gaiyo-item item-1">{{fmt(gaiyo.gaiyoRec.nB_AREA_YOSEKI, 2)}} ％</div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data () {
    return {
      itemHeaderCols: 4,
      subItemCols: 3,
    }
  },
  props: {
    gaiyo: {
      type: Object,
      default: null
    },
  },
  computed: {
  },
  methods: {
    fmt(val, prec, blancIfNull = true) {
      if (val === null && blancIfNull) {
        return '';
      }
      const v = (val == null) ? 0 : val;
      return v.toFixed(prec);
    },
  },
}
</script>

<style lang="scss" scoped>
.gaiyo-row {
  line-height: 3.4mm;
}
</style>